<template>
  <div class="change-state-form bg-white px-4 py-5 border-b border-gray-200 sm:px-6">
    <div class="-ml-4 -mt-4 flex justify-between items-center flex-wrap sm:flex-nowrap">
      <div class="ml-4 mt-4">
        <h3 class="text-lg leading-6 font-medium text-gray-900">
          Change the Status
        </h3>
        <p class="mt-1 text-sm leading-5 text-gray-500">
          All of the Roles that have been selected will be altered to have the status of your choice.
        </p>
      </div>
    </div>
    <div class="modal-body">
      <multiselect
        v-model="selectedState"
        :options="validStates"
        placeholder="Select status"
        :show-labels="false"
        :multiple="false"
      />
      
      <div class="action-buttons">
        <button type="button" class="btn btn-danger" @click="cancel">Cancel</button>
        <button type="button" class="btn btn-primary" @click="submit" :disabled="!selectedState">Submit</button>
      </div>
    </div>
  </div>
</template>

<script>
  import { startCase } from 'lodash-es'
  import Multiselect from 'vue-multiselect'
  import BulkActionService from '@services/BulkActionService'
  import FlashMessages from '@services/FlashMessages'
  import flatpickr from 'flatpickr'

  export default {
    name: 'assign-reporting-entities-form',
    components: {
      Multiselect,
    },
    data () {
      return {
        selectedState: null,
        processing: false,
      }
    },
    computed: {
      validStates() {
        return this.model == 'PersonRoleReps' ? ['active', 'inactive', 'paused'] : ['active', 'inactive']
      },
      stateNamePrettified () {
        return this.selectedState ? startCase(this.selectedState.replace('_',' ')) : ''
      },
      validationErrors () {
        let errorText = ''
        return errorText
      },
      baseModel () {
        return this.model.startsWith('PersonRole') ? 'PersonRole' : this.model
      }
    },
    methods: {
      cancel () {
        this.$emit('cancel')
      },
      close () {
        this.$emit('close')
      },
      submit () {
        if (!this.processing) {
          this.processing = true
          if (this.validationErrors == '') {
            BulkActionService.changeState(this.ids, this.baseModel, this.selectedState)
              .then(resp => {
                console.log("resp", resp)
                
                FlashMessages.success(`Status changed to \"${this.selectedState}\" on ${resp.data.result} record(s).`, 'Success')
                this.close()
              })
              .catch(resp => {
                console.log("resp", resp)

                FlashMessages.error(`Failed to change status. Please try again later.`, 'Error')
                this.close()
              })
          } else {
            FlashMessages.error(this.validationErrors)
          }
        }
      },
    },
    created () {
      let itvl = setInterval(() => {
        if (this.$refs.datepicker) {
          flatpickr(this.$refs.datepicker)
          clearInterval(itvl)
        }
      }, 50)
    },
    props: {
      ids: {
        type: Array,
        required: true,
      },
      model: {
        type: String,
        required: true,
      },
      options: {
        type: Object,
        required: false,
      },
    },
  }
</script>

<style lang="scss">
  .change-state-form {
    .modal-body {
      margin-top: 15px;

      .action-buttons {
        margin-top: 15px;
        display: flex;
        justify-content: space-between;
      }
      .multiselector {
        margin-top: 5px;
        min-width: 20rem;
        max-width: 20rem;
      }
    }
  }
</style>
